module.exports = __webpack_public_path__ + "img/logo-icon.2d799735.svg";